import React, { useContext, useEffect, useState } from "react";
import Context from "../context/CartContext";
import { cargarAllLocales } from "../services/locales";
import { saveAs } from "file-saver";
import { ENDPOINT } from "../config/endpoint.jsx";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";

function EnviarExcelTabla({ proveedor, idProveedor }) {
  const navigate = useNavigate();
  const [locales, setLocales] = useState([]);
  const [selectedLocal, setSelectedLocal] = useState("");
  const [comentario, setComentario] = useState("");
  const [cargando, setCargando] = useState(false);
  const { cart, setCart } = useContext(Context);

  useEffect(() => {
    cargarAllLocales()
      .then((data) => {
        setLocales(data);
        if (data.length > 0) setSelectedLocal(data[0].id);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    if (cargando) {
      Swal.fire({
        title: "Generando el Excel",
        html: '<div class="flex justify-center"><div class="w-8 h-8 border-4 border-pons-500 border-t-transparent rounded-full animate-spin"></div></div>',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } else {
      Swal.close();
    }
  }, [cargando]);

  const enviarDatos = async () => {
    try {
      const local = locales.find((l) => l.id === Number(selectedLocal));
      const payload = {
        cart,
        comentario,
        direccion: local.direccion,
        proveedor,
        idProveedor,
      };

      const response = await fetch(ENDPOINT + "/generar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setCargando(false);
        const blob = await response.blob();
        saveAs(blob, `Pedido_${proveedor}_${new Date().toLocaleDateString()}.xlsx`);
        Swal.fire({
          title: "Excel Generado!",
          text: "Se ha descargado automaticamente y estara en la seccion 'Ver Excel'",
          icon: "success",
          confirmButtonText: "Ok!",
          didClose: () => {
            setCart([]);
            navigate("/home");
          },
        });
      } else {
        setCargando(false);
        console.error("Error al enviar los datos:", response.statusText);
        Swal.fire({
          title: "Error",
          text: "No se pudo generar el Excel",
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    } catch (error) {
      setCargando(false);
      console.error("Error al enviar los datos:", error);
      Swal.fire({
        title: "Error de conexion",
        text: "No se pudo conectar con el servidor",
        icon: "error",
        confirmButtonText: "Ok!",
      });
    }
  };

  return (
    <div className="card p-5 space-y-4">
      <div className="flex items-center gap-2 mb-2">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <h3 className="font-bold text-ink">Exportar a Excel</h3>
      </div>

      <div>
        <label className="label-field">Comentario Adicional (opcional):</label>
        <input
          className="input-field"
          type="text"
          placeholder="Nota para el pedido..."
          value={comentario}
          onChange={(e) => setComentario(e.target.value)}
        />
      </div>

      <div>
        <label className="label-field">Local de Despacho:</label>
        <select
          className="select-field"
          value={selectedLocal}
          onChange={(e) => setSelectedLocal(e.target.value)}
        >
          {locales.map((element) => (
            <option key={element.id} value={element.id}>
              {element.direccion}
            </option>
          ))}
        </select>
      </div>

      <button
        className="btn-success w-full"
        onClick={() => {
          setCargando(true);
          enviarDatos();
        }}
      >
        Generar y Descargar Excel
      </button>
    </div>
  );
}

export default EnviarExcelTabla;
